import styled from 'styled-components';

export const Instruction = styled.span`
    font-size: 24px;
    color: #ffffff;
    font-weight: 300;
`;
